import HappyGiftIcon from '@stencil/icons/src/HappyGiftIcon/HappyGiftIcon';
import HappyGoNewIcon from '@stencil/icons/src/HappyGoNewIcon/HappyGoNewIcon';

import * as S from './GoStreaksBar.styles';

interface GoStreaksBarProps {
  completedBookings: number;
  inProgressBookings: number;
  showTracker: boolean;
  maxBookings: number;
  isMyEarning?: boolean;
}

const GoStreaksBar: React.FC<GoStreaksBarProps> = ({
  completedBookings = 0,
  inProgressBookings = 0,
  maxBookings = 5,
  showTracker = false,
  isMyEarning = false,
}) => {
  let totalBookings = completedBookings + inProgressBookings;

  let progressBookings = inProgressBookings;

  if (totalBookings > maxBookings) {
    progressBookings = maxBookings - completedBookings;
    totalBookings = maxBookings;
  }

  if (!showTracker) {
    return null;
  }

  return (
    <S.GoStreakBarOuterWrapper isMyEarning={isMyEarning}>
      <S.GoStreakBarWrapper>
        {/* // @Note this generates goStreaks round icon */}
        {totalBookings !== maxBookings && (
          <S.GoStreakBarIconWrapper
            count
            width={`${totalBookings * 20}%`}
            isMyEarning={isMyEarning}
          >
            <HappyGoNewIcon width="1.3rem" height="1rem" />
          </S.GoStreakBarIconWrapper>
        )}

        {/* // @Note this generates the whole line */}
        {new Array(maxBookings).fill(0).map((_, index) => {
          return (
            <S.GoStreakBarWrapperItem
              isComplete={index < totalBookings}
              key={`goStreakFilledBar_${index}`}
            ></S.GoStreakBarWrapperItem>
          );
        })}

        {/* // @Note this generates the dividers */}
        {new Array(maxBookings - 1).fill(0).map((_, index) => {
          return (
            <S.BlockBarWrapper
              className="blockBar"
              left={`${(index + 1) * 20}%`}
              key={`goStreakWhiteDivider_${index}`}
            ></S.BlockBarWrapper>
          );
        })}

        {/* // @Note this generates and superimposes the gradient as per completed bookings */}
        <S.BlockProgress
          className={`${totalBookings === 1 && 'first'} ${totalBookings === 5 && 'last'}`}
          width={`${totalBookings * 20}%`}
        ></S.BlockProgress>

        {/* // @Note this generates and superimposes the progress bar lines */}
        <S.LoadingLineOuterWrapper
          className={`${totalBookings === 1 && 'first'} ${totalBookings === 5 && 'last'}`}
          stayCount={completedBookings}
          width={`${progressBookings * 20}%`}
        >
          <S.BlockProgressLoading
            className={`${totalBookings === 1 && 'first'} ${totalBookings === 5 && 'last'}`}
            stayCount={totalBookings}
            width={`${progressBookings * 20}%`}
          >
            {new Array(totalBookings * 30).fill(0).map((_, index) => {
              return (
                <S.LoadingLine
                  className="loadingLine"
                  index={index}
                  key={`goStreakProgressBar_${index}`}
                ></S.LoadingLine>
              );
            })}
          </S.BlockProgressLoading>
        </S.LoadingLineOuterWrapper>
        <S.BlockIndicator></S.BlockIndicator>
      </S.GoStreakBarWrapper>
      {isMyEarning ? (
        <div className="giftIconWrapper">
          <HappyGiftIcon margin="0 0 0.4rem 0.6rem" />
        </div>
      ) : (
        <HappyGiftIcon margin="0 0 0.4rem 0.6rem" />
      )}
    </S.GoStreakBarOuterWrapper>
  );
};

export default GoStreaksBar;
